import script from "./PublicLayoutCotizar.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicLayoutCotizar.vue?vue&type=script&setup=true&lang=js"

import "./PublicLayoutCotizar.vue?vue&type=style&index=0&id=2a134e09&lang=css"

const __exports__ = script;

export default __exports__